import React, { Fragment } from 'react';
import SettingsFormContainer from './SettingsFormContainer';
import { TextInputField, InlineAlert } from 'evergreen-ui';
import { isValidEmail } from '../../../utils';
import ImageUploadField from '../../../components/ImageUploadField';

const SettingsUserInformation = ({
  title,
  description,
  icon,
  infoLoader,
  infoUpdateLoader,
  userInfo,
  handleChange,
  handleImageChange,
  handleImageClear,
  isUserInfoChanged,
  handleSave,
  handleCancel,
}) => {
  return (
    <SettingsFormContainer
      id='user-settings'
      title={title}
      description={description}
      icon={icon}
      hasData={!!userInfo}
      infoLoader={infoLoader}
      infoUpdateLoader={infoUpdateLoader}
      isInfoChanged={isUserInfoChanged}
      handleSave={handleSave}
      handleCancel={handleCancel}
    >
      {userInfo && (
        <Fragment>
          <div className='settings-name__container'>
            <TextInputField
              className='settings-input w-100p-mr-10px'
              marginRight={10}
              label='First Name'
              name={'first_name'}
              onChange={(e) =>
                e.target.value.length <= 160 &&
                handleChange(e.target.name, e.target.value)
              }
              value={userInfo.first_name}
              placeholder='Please provide first name of this user...'
            />
            <TextInputField
              className='settings-input w-100p'
              label='Last Name'
              name={'last_name'}
              onChange={(e) =>
                e.target.value.length <= 160 &&
                handleChange(e.target.name, e.target.value)
              }
              value={userInfo.last_name}
              placeholder='Please provide last name of this user...'
            />
          </div>
          <TextInputField
            className='settings-input'
            label='Email Address'
            type='email'
            name={'email'}
            hint={
              userInfo.email !== '' &&
              !isValidEmail(userInfo.email) && (
                <InlineAlert intent='warning' marginTop={10}>
                  Email Address is Invalid
                </InlineAlert>
              )
            }
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            value={userInfo.email}
            placeholder='Please provide email address of this user...'
          />
          <p className='input-label'>User Avatar</p>
          <ImageUploadField
            image={userInfo.avatar}
            handleDrop={(image) => handleImageChange(image)}
            handleClear={() => handleImageClear()}
          />
        </Fragment>
      )}
    </SettingsFormContainer>
  );
};

export default SettingsUserInformation;
